import BpDataTable from "./BpDataTable.vue";

export default BpDataTable;
